// Campos
// Data Referência,
//     Data Validade,
//     CPFCNPJ, Fonte,
//     ScoreRating,
//     Rating,
//     Sinal,
//     Pespectiva,
//     Observação,
//     AnaliseResumoCredito.
//
//
//     (Os demais campos num futuro serão excluídos da tabela pois estarão em duplicidade com MC_RendaFixaCaracterísticas).
//
// A tabela retornará o registro com a data referencia mais recente para o CETIP caso tenha, se não retornar vazio no front.
//
import {ensureString, formatDateBr} from "../../../utils/convert-fields"

const dateMask = "99/99/9999"
export const ratingFields = [
    {
        key: "DataReferencia",
        label: "Data Referência",
        md: 4,
        defaultValue: null,
        mask: dateMask,
        maskType: "date",
        minDate: "01/01/1900",
    },
    {
        key: "DataValidade",
        label: "Data Validade",
        md: 4,
        defaultValue: null,
        mask: dateMask,
        maskType: "date",
        minDate: "01/01/1900",
    },
    {key: "CPFCNPJ", label: "CPF / CNPJ", md: 4, defaultValue: null},
    {key: "Fonte", label: "Fonte", md: 4, defaultValue: null},
    {key: "ScoreRating", label: "Score Rating", md: 4, defaultValue: null},
    {key: "Rating", label: "Rating", md: 4, defaultValue: null},
    {key: "Sinal", label: "Sinal", md: 4, defaultValue: null},
    {key: "Pespectiva", label: "Pespectiva", md: 4, defaultValue: null},
    {key: "Observacao", label: "Observação", md: 4, defaultValue: null},
    {key: "AnaliseCreditoEmissao", label: "Análise Resumo Crédito", md: 4, defaultValue: null},
]

export const mapRatingEmissao = (ratingEmissao) => {
    return {
        "DataReferencia": formatDateBr(ratingEmissao.DataReferencia),
        "DataValidade":  formatDateBr(ratingEmissao.DataValidade),
        "CPFCNPJ": ensureString(ratingEmissao.CPFCNPJ),
        "Fonte": ensureString(ratingEmissao.Fonte),
        "ScoreRating": ensureString(ratingEmissao.ScoreRating),
        "Rating": ensureString(ratingEmissao.Rating),
        "Sinal": ensureString(ratingEmissao.Sinal),
        "Pespectiva": ensureString(ratingEmissao.Pespectiva),
        "Observacao": ensureString(ratingEmissao.Observacao),
        "AnaliseCreditoEmissao": ensureString(ratingEmissao.AnaliseCreditoEmissao)
    }
}